import validate from "/builds/hotelschool-the-hague/hotelschool-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import history_45global from "/builds/hotelschool-the-hague/hotelschool-frontend/middleware/history.global.ts";
import manifest_45route_45rule from "/builds/hotelschool-the-hague/hotelschool-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  history_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}